import classnames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
// utils
import { Translations, convertStringToArray, convertStringToArrayForOption, convertStringToArrayForRadio, electOwningCase } from '../../../../utils';
// constant
import {
  ADMIN_ROLE,
  CASE_WORKER_ROLE,
  CI_APPROVED,
  CI_REJECTED,
  CUSTOMER_APPROVED,
  CUSTOMER_REJECTED,
  DATA_COMPLETE,
  DATA_INCOMPLETE,
  READY_FOR_CI_APPROVAL,
  READY_FOR_CUSTOMER_REVIEW,
  UNCLICKABLE_GLS_ACTIVATIONS_STATUSES
} from '../../../../constants';
// restClient
import { aemHostClient, eapiClient } from '../../../../restClient';
// children
import CheckBox from '../../../common/Checkbox';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../../common/Modal';
import Radiobutton from '../../../common/Radio/radioButton';
//style
import './GlsActivationList.css';

class GlsActivationList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showConfirmationSection: false,
      consentsGiven: {},
      currentProduct: {
        glsProductType: {},
        glsAgent: {},
        statusText: this.translations(this.props.pageJson.par.documentation_pack_glsProducts.statusText)
      },
      glsProduct: [],
      radioVisible: true,
      makerCheckerProcess: {
        cashcon: '',
        interest: '',
        notionalPool: ''
      },
      customerAckProcess: {
        cashcon: '',
        interest: '',
        notionalPool: ''
      },
      showSSFCommentsModal: false,
      ssfComments: []
    };

    this.customerStatusLookUp = {
      [DATA_INCOMPLETE]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.customerstatuslookup[0]).split("=")[0] === "DATA_INCOMPLETE" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.customerstatuslookup[0]).split("=")[1] : 'DATA INCOMPLETE' : '',
      [DATA_COMPLETE]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.customerstatuslookup[1]).split("=")[0] === "DATA_COMPLETE" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.customerstatuslookup[1]).split("=")[1] : 'DATA COMPLETE' : '',
      [READY_FOR_CI_APPROVAL]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.customerstatuslookup[2]).split("=")[0] === "READY_FOR_CI_APPROVAL" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.customerstatuslookup[2]).split("=")[1] : 'PENDING ACTIVATION' : '',
      [CI_APPROVED]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.customerstatuslookup[3]).split("=")[0] === "CI_APPROVED" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.customerstatuslookup[3]).split("=")[1] : 'PENDING ACTIVATION' : '',
      [CI_REJECTED]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.customerstatuslookup[4]).split("=")[0] === "CI_REJECTED" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.customerstatuslookup[4]).split("=")[1] : 'PENDING ACTIVATION' : '',
      [READY_FOR_CUSTOMER_REVIEW]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.customerstatuslookup[5]).split("=")[0] === "READY_FOR_CUSTOMER_REVIEW" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.customerstatuslookup[5]).split("=")[1] : 'AWAITING CUSTOMER APPROVAL' : '',
      [CUSTOMER_APPROVED]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.customerstatuslookup[6]).split("=")[0] === "CUSTOMER_APPROVED" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.customerStatusLookUp[6]).split("=")[1] : 'ACTIVATED' : '',
      [CUSTOMER_REJECTED]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.customerstatuslookup[7]).split("=")[0] === "CUSTOMER_REJECTED" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.customerStatusLookUp[7]).split("=")[1] : 'CUSTOMER REJECTED' : ''
    };
    this.ciMakerStatusLookUp = {
      [DATA_INCOMPLETE]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.cicheckerstatuslookup[0]).split("=")[0] === "DATA_INCOMPLETE" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.ciCheckerStatusLookUp[0]).split("=")[1] : 'DATA INCOMPLETE' : '',
      [DATA_COMPLETE]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.cicheckerstatuslookup[1]).split("=")[0] === "DATA_COMPLETE" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.ciCheckerStatusLookUp[1]).split("=")[1] : 'DATA COMPLETE' : '',
      [READY_FOR_CI_APPROVAL]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.cicheckerstatuslookup[2]).split("=")[0] === "READY_FOR_CI_APPROVAL" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.ciCheckerStatusLookUp[2]).split("=")[1] : 'AWAITING CI APPROVAL' : '',
      [CI_APPROVED]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.cicheckerstatuslookup[3]).split("=")[0] === "CI_APPROVED" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.ciCheckerStatusLookUp[3]).split("=")[1] : 'CI APPROVED' : '',
      [CI_REJECTED]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.cicheckerstatuslookup[4]).split("=")[0] === "CI_REJECTED" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.ciCheckerStatusLookUp[4]).split("=")[1] : 'CI REJECTED' : '',
      [READY_FOR_CUSTOMER_REVIEW]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.cicheckerstatuslookup[5]).split("=")[0] === "READY_FOR_CUSTOMER_REVIEW" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.ciCheckerStatusLookUp[5]).split("=")[1] : 'AWAITING CUSTOMER APPROVAL' : '',
      [CUSTOMER_APPROVED]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.cicheckerstatuslookup[6]).split("=")[0] === "CUSTOMER_APPROVED" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.ciCheckerStatusLookUp[6]).split("=")[1] : 'ACTIVATED' : '',
      [CUSTOMER_REJECTED]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.cicheckerstatuslookup[7]).split("=")[0] === "CUSTOMER_REJECTED" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.ciCheckerStatusLookUp[7]).split("=")[1] : 'CUSTOMER REJECTED' : ''
    };
    this.ciCheckerStatusLookUp = {
      [DATA_INCOMPLETE]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.cicheckerstatuslookup[0]).split("=")[0] === "DATA_INCOMPLETE" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.ciCheckerStatusLookUp[0]).split("=")[1] : 'DATA INCOMPLETE' : '',
      [DATA_COMPLETE]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.cicheckerstatuslookup[1]).split("=")[0] === "DATA_COMPLETE" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.ciCheckerStatusLookUp[1]).split("=")[1] : 'DATA COMPLETE' : '',
      [READY_FOR_CI_APPROVAL]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.cicheckerstatuslookup[2]).split("=")[0] === "READY_FOR_CI_APPROVAL" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.ciCheckerStatusLookUp[2]).split("=")[1] : 'AWAITING CI APPROVAL' : '',
      [CI_APPROVED]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.cicheckerstatuslookup[3]).split("=")[0] === "CI_APPROVED" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.ciCheckerStatusLookUp[3]).split("=")[1] : 'CI APPROVED' : '',
      [CI_REJECTED]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.cicheckerstatuslookup[4]).split("=")[0] === "CI_REJECTED" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.ciCheckerStatusLookUp[4]).split("=")[1] : 'CI REJECTED' : '',
      [READY_FOR_CUSTOMER_REVIEW]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.cicheckerstatuslookup[5]).split("=")[0] === "READY_FOR_CUSTOMER_REVIEW" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.ciCheckerStatusLookUp[5]).split("=")[1] : 'AWAITING CUSTOMER APPROVAL' : '',
      [CUSTOMER_APPROVED]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.cicheckerstatuslookup[6]).split("=")[0] === "CUSTOMER_APPROVED" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.ciCheckerStatusLookUp[6]).split("=")[1] : 'ACTIVATED' : '',
      [CUSTOMER_REJECTED]: this.props.glsApprovalComments ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.cicheckerstatuslookup[7]).split("=")[0] === "CUSTOMER_REJECTED" ? this.translations(this.props.glsApprovalComments.navigation_list_commentList.ciCheckerStatusLookUp[7]).split("=")[1] : 'CUSTOMER REJECTED' : ''
    };
    this.pollingApiTimerId = null
  }

  componentWillMount() {
    // Reject jls proudct modal
    aemHostClient("/aemData/formData/json_reject-gls-product")
      .then(({ data }) => {
        this.setState({ rejectGlsProduct: data.par });
      });

    aemHostClient("/aemData/formData/json_gls-approval-comments")
      .then(({ data }) => {
        this.setState({ glsApprovalComments: data.par });
      });

    aemHostClient("/aemData/formData/json_gls-submit-to-ci-checker")
      .then(({ data }) => {
        this.setState({ glsSubmitToCiChecker: data.par });
      });

    aemHostClient("/aemData/formData/json_gls-submit-to-clientsphere")
      .then(({ data }) => {
        this.setState({ glsSubmitToClientSphere: data.par });
      });

    aemHostClient("/aemData/formData/json_gls-customer-acknowledgement-within-gdocs-portal")
      .then(({ data }) => {
        this.setState({ glsCustomerAckWithinGDOCS: data.par });
      });

    aemHostClient("/aemData/formData/json_gls-customer-acknowledgement-outside-gdocs-portal")
      .then(({ data }) => {
        this.setState({ glsCustomerAckOutsideGDOCS: data.par });
      });

    this.setState({ glsProductsList: this.props.glsProductsList })
    this.getSSFComments()
    this.getDocStatus()
  }

  componentWillUnmount() {
    this.stopPollingApi()
  }

  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWordForRadio = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForRadio(currentWord);
    return convertedArray;
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  checkForOwner = () => {
    const caseOwner = this.props.caseOwner.filter(participant =>
      participant.id === this.props.currentUser.roleDetails.id
    )
    return caseOwner.length > 0 ? true : false;
  }

  // Getting product status based on Role
  getProductStatusBasedOnRole = (status, ownerId) => {
    if (this.props.customer === true) {
      return this.customerStatusLookUp[status];
    } else if (this.props.role === ADMIN_ROLE || this.props.role === CASE_WORKER_ROLE ||
      this.checkForOwner()) {
      return this.ciMakerStatusLookUp[status];
    } else {
      return this.ciCheckerStatusLookUp[status];
    }
  }

  // Open comment pop up modal
  openCommentsModal = (product) => {
    this.setState({
      showCommentsModal: true,
      currentProductComments: product.comments || [],
      currentProduct: product
    });
  }

  // post comment URL
  postComment = (productId, comment) => {
    eapiClient(`/product/gls/${productId}/comments`, {
      method: 'POST',
      data: JSON.stringify({ comment })
    })
      .then(({ data }) => {
        this.setState({ currentProductComments: [...this.state.currentProductComments, data.responseData] });
      });
  }

  // TOGGLE Modal
  toggleCommentsModal = () => {
    this.setState({
      showCommentsModal: false
    });
    this.props.onActionPerformed();
  }

  // Render status and Comment Section
  renderStatusAndCommentsSection = (product) => {
    let status = this.getProductStatusBasedOnRole(product.activationStatus, product.ownerId)
    return (
      <div className="gls-activation-list__item__body__status-and-comments-section">
        {status === "ACTIVATED" ? <p className="product-status">{status} {product.activationDate}</p> :
          <p className="product-status">{status}</p>}
        <a
          className="activation-comments-link"
          onClick={this.openCommentsModal.bind(this, product)}
          href='#'
          tabindex="0"
        >
          {`${product.comments.length} ${this.translations(this.props.pageJson.par.comments_commentText.message1)}`}
        </a>
      </div>
    );
  }

  // Toggle submit to Checker Modal
  toggleSubmitToChekerModal = () => {
    this.setState({
      showSubmitToCheckerModal: false,
      showClientSphereCheckerModal: false,
      showWithinGdocsModal: false,
      showOutsideGdocsModal: false
    });
  }

  //Submit to Checker
  submitToChecker = (productId) => {
    this.setState({
      showSubmitToCheckerModal: true,
      currentProductId: productId
    });
  }

  setMakerChecker = (productId, productType) => {
    if (this.state.makerCheckerProcess[productType] === true) {
      this.submitToChecker(productId);
    } else if (this.state.makerCheckerProcess[productType] === false) {
      this.setState({
        showClientSphereCheckerModal: true,
        currentProductId: productId
      });
    }
  }

  setCustomerAck = (productId, productType) => {
    if (this.state.customerAckProcess[productType] === true) {
      this.setState({
        showWithinGdocsModal: true,
        currentProductId: productId
      });
    } else if (this.state.customerAckProcess[productType] === false) {
      this.setState({
        showOutsideGdocsModal: true,
        currentProductId: productId
      });
    }
  }

  // payload to submit to checker
  _onSubmitToChecker = (email) => {
    eapiClient(`/product/gls/${this.state.currentProductId}/sendToCIChecker`, {
      method: 'POST',
      data: JSON.stringify({ email })
    })
      .then(({ data, status }) => {
        this.setState({ showSubmitToCheckerModal: false });
        if (this.props.onActionPerformed) {
          this.props.onActionPerformed();
        }
      });
  }

  // payload to submit to checker
  _onSubmitToClientSphere = () => {
    eapiClient(`/product/gls/${this.state.currentProductId}/cs-approved`, {
      method: 'POST'
    })
      .then(({ data, status }) => {
        this.setState({ showClientSphereCheckerModal: false });
        if (this.props.onActionPerformed) {
          this.props.onActionPerformed();
        }
      });
  }

  // Recall
  makerReCall = (productId, productType) => {
    eapiClient(`/product/gls/${productId}/recall`, { method: 'POST' })
      .then(({ data, status }) => {
        if (productType === "cashcon") {
          this.setState({
            makerCheckerProcess: { ...this.state.makerCheckerProcess, cashcon: '' },
            customerAckProcess: { ...this.state.customerAckProcess, cashcon: '' }
          })
        } else if (productType === "interest") {
          this.setState({
            makerCheckerProcess: { ...this.state.makerCheckerProcess, interest: '' },
            customerAckProcess: { ...this.state.customerAckProcess, interest: '' }
          })
        } else if (productType === "notionalPool") {
          this.setState({
            makerCheckerProcess: { ...this.state.makerCheckerProcess, notionalPool: '' },
            customerAckProcess: { ...this.state.customerAckProcess, notionalPool: '' }
          })
        }
        if (this.props.onActionPerformed) {
          this.props.onActionPerformed();
        }
      });
  }

  // Toggle Reject Modal
  toggleRejectModal = () => {
    this.setState({ showRejectModal: false });
  }

  // CI Reject
  onCIReject = (product) => {
    this.setState({
      showRejectModal: true,
      currentProductId: product.id,
      currentProduct: product,
      rejectType: 'CI_REJECT'
    });
  }

  // Customer Reject
  onCustomerReject = (product) => {
    this.setState({
      showRejectModal: true,
      currentProductId: product.id,
      currentProduct: product,
      rejectType: 'CUSTOMER_REJECT'
    });
  }

  // Product Reject
  _onProductRejected = (rejectType, rejectedReason) => {
    var rejectApiURL = '';
    if (rejectType === 'CI_REJECT') {
      rejectApiURL = `/product/gls/${this.state.currentProductId}/cIRejected`;
    } else if (rejectType === 'CUSTOMER_REJECT') {
      rejectApiURL = `/product/gls/${this.state.currentProductId}/customerRejected`;
    }
    this.toggleRejectModal();
    eapiClient(rejectApiURL, {
      method: 'POST',
      data: JSON.stringify({ rejectedReason })
    })
      .then(({ data, status }) => {
        if (this.props.onActionPerformed) {
          this.props.onActionPerformed();
        }
      });
  }

  // On CI Approve
  onCIApprove = (productId) => {
    eapiClient(`/product/gls/${productId}/cIApproved`, { method: 'POST' })
      .then(({ data, status }) => {
        if (this.props.onActionPerformed) {
          this.props.onActionPerformed();
        }
      });
  }


  // Submit Customer payload
  submitToCustomer = () => {
    eapiClient(`/product/gls/${this.state.currentProductId}/sendToCustomer`, { method: 'POST' })
      .then(({ data, status }) => {
        this.setState({ showWithinGdocsModal: false });
        if (this.props.onActionPerformed) {
          this.props.onActionPerformed();
        }
      });
  }

  // Submit Customer payload
  submitToCustomerOutsidePortal = () => {
    eapiClient(`/product/gls/${this.state.currentProductId}/cs-activated`, { method: 'POST' })
      .then(({ data, status }) => {
        this.setState({ showOutsideGdocsModal: false });
        if (this.props.onActionPerformed) {
          this.props.onActionPerformed();
        }
      });
  }

  // Customer Approve
  onCustomerApprove = (productId) => {
    eapiClient(`/product/gls/${productId}/customerApproved`, { method: 'POST' })
      .then(({ data, status }) => {
        if (this.props.onActionPerformed) {
          this.props.onActionPerformed();
        }
      });
  }

  // Get customer Actions
  getCustomerActions = (product, index) => {
    var status = product.activationStatus;
    var productId = product.id;
    var btnName = this.translateWord(this.props.pageJson.par.documentation_pack_glsProducts.buttonText)

    switch (status) {
      case DATA_COMPLETE:
        return '';
      case READY_FOR_CI_APPROVAL:
        return '';
      case CI_APPROVED:
        return '';
      case CI_REJECTED:
        return '';
      case READY_FOR_CUSTOMER_REVIEW:
        return [
          <button
            className="gdocs-btn-default reject-btn"
            key="customer-reject-button"
            onClick={this.onCustomerReject.bind(this, product)}
          >
            {btnName[3]}
          </button>,
          <button
            disabled={this.state.consentsGiven[productId] !== true}
            className="gdocs-btn-primary approve-btn"
            key="customer-approve-button"
            onClick={this.onCustomerApprove.bind(this, productId)}
          >
            {btnName[4]}
          </button>
        ];
      case CUSTOMER_APPROVED:
        return (
          <div className="final-status">
            <span className="status-text">{btnName[5]}</span>
            <i className="icon icon-circle-confirmation-solid"></i>
          </div>
        );
      case CUSTOMER_REJECTED:
        return '';
      default:
        return '';
    }
  }

  getMakerCheckerSection(productId, productType) {
    const checkerJsx = <div>
      <div className="form-column">
        <label>
          {this.translations(this.props.pageJson.par.guideradiobutton_MakerCheckerprocess.title)}
        </label>
        <label className="radio-label">
          {this.translateWordForRadio(this.props.pageJson.par.guideradiobutton_MakerCheckerprocess.options)[0].split('=')[1]}
          <Radiobutton
            setInputvalue={(value) => this.setMakerCheckerSelection(value, productType)}
            name={`${productType}_makerChecker_GDocs`}
            id={`${productType}_1`}
            _value={this.state.makerCheckerProcess[productType]}
            value={this.translateWordForRadio(this.props.pageJson.par.guideradiobutton_MakerCheckerprocess.options)[0].split('=')[0]}
          />
        </label>
        <label className="radio-label">
          {this.translateWordForRadio(this.props.pageJson.par.guideradiobutton_MakerCheckerprocess.options)[1].split('=')[1]}
          <Radiobutton
            setInputvalue={(value) => this.setMakerCheckerSelection(value, productType)}
            name={`${productType}_makerChecker_GDocs`}
            id={`${productType}_2`}
            _value={this.state.makerCheckerProcess[productType]}
            value={this.translateWordForRadio(this.props.pageJson.par.guideradiobutton_MakerCheckerprocess.options)[1].split('=')[0]}
          />
        </label>
      </div>
      <div className="form-column">
        <button
          className="gdocs-btn-default"
          onClick={this.setMakerChecker.bind(this, productId, productType)}
          disabled={this.state.makerCheckerProcess[productType] === ''}
        >
          {this.translations(this.props.pageJson.par.button_submit.name)}
        </button>
      </div>
    </div>

    return checkerJsx;
  }

  setMakerCheckerSelection = (value, type) => {
    switch (type) {
      case "cashcon":
        this.setState({ makerCheckerProcess: { ...this.state.makerCheckerProcess, cashcon: value } })
        break;
      case "interest":
        this.setState({ makerCheckerProcess: { ...this.state.makerCheckerProcess, interest: value } })
        break;
      case "notionalPool":
        this.setState({ makerCheckerProcess: { ...this.state.makerCheckerProcess, notionalPool: value } })
        break;
    }
  }

  setCustomerAckSelection = (value, type) => {
    switch (type) {
      case "cashcon":
        this.setState({ customerAckProcess: { ...this.state.customerAckProcess, cashcon: value } })
        break;
      case "interest":
        this.setState({ customerAckProcess: { ...this.state.customerAckProcess, interest: value } })
        break;
      case "notionalPool":
        this.setState({ customerAckProcess: { ...this.state.customerAckProcess, notionalPool: value } })
        break;
    }
  }

  getCIMakerActions = (product) => {
    var status = product.activationStatus;
    var productId = product.id;
    var productType = product.glsProductType.value
    var btnName = this.translateWord(this.props.pageJson.par.documentation_pack_glsProducts.buttonText)
    // if(product.customerAck=== false){   //  customer ack radio comment
    //   status = 'ACTIVE'
    // }
    switch (status) {
      case DATA_COMPLETE:
        return this.getMakerCheckerSection(productId, productType);
      case READY_FOR_CI_APPROVAL:
        return (<button
          className="gdocs-btn-default"
          onClick={this.makerReCall.bind(this, productId, productType)}
        >
          {btnName[2]}
        </button>
        );
      case CI_APPROVED:
        // return (product.customerAck === true ? <button
        return (<div>
          <div className="form-column">
            <label>
              {this.translations(this.props.pageJson.par.guideradiobutton_Customeracknowledgement.title)}
            </label>
            <label className="radio-label">
              {this.translateWordForRadio(this.props.pageJson.par.guideradiobutton_Customeracknowledgement.options)[0].split('=')[1]}
              <Radiobutton
                setInputvalue={(value) => this.setCustomerAckSelection(value, productType)}
                name={`${productType}_customerAck_withinGDocs`}
                _value={this.state.customerAckProcess[productType]}
                value={this.translateWordForRadio(this.props.pageJson.par.guideradiobutton_Customeracknowledgement.options)[0].split('=')[0]}
              />
            </label>
            <label className="radio-label">
              {this.translateWordForRadio(this.props.pageJson.par.guideradiobutton_Customeracknowledgement.options)[1].split('=')[1]}
              <Radiobutton
                setInputvalue={(value) => this.setCustomerAckSelection(value, productType)}
                name={`${productType}_customerAck_withinGDocs`}
                _value={this.state.customerAckProcess[productType]}
                value={this.translateWordForRadio(this.props.pageJson.par.guideradiobutton_Customeracknowledgement.options)[1].split('=')[0]}
              />
            </label>
          </div>
          <div className="form-column">
            <button
              className="gdocs-btn-default"
              onClick={this.setCustomerAck.bind(this, productId, productType)}
              disabled={this.state.customerAckProcess[productType] === ''}
            >
              {this.translations(this.props.pageJson.par.button_submit.name)}
            </button>
          </div>
        </div>
        );
      case CI_REJECTED:
        return this.getMakerCheckerSection(productId, productType);
      case READY_FOR_CUSTOMER_REVIEW:
        return (<button
          className="gdocs-btn-default"
          onClick={this.makerReCall.bind(this, productId, productType)}
        >
          {btnName[2]}
        </button>
        );
      case CUSTOMER_APPROVED:
        return (
          <div className="final-status">
            <span className="status-text">{btnName[5]}</span>
            <i className="icon icon-circle-confirmation-solid"></i>
          </div>
        );
      case CUSTOMER_REJECTED:
        return this.getMakerCheckerSection(productId, productType);
      default:
        return '';
    }
  }

  getCICheckerActions = (product) => {
    var status = product.activationStatus;
    var productId = product.id;
    var productType = product.glsProductType.value;
    var btnName = this.translateWord(this.props.pageJson.par.documentation_pack_glsProducts.buttonText)

    switch (status) {
      case DATA_COMPLETE:
        return '';
      case READY_FOR_CI_APPROVAL:
        return ''
      case CI_APPROVED:
        return '';
      case CI_REJECTED:
        return this.getMakerCheckerSection(productId, productType);
      case READY_FOR_CUSTOMER_REVIEW:
        return ''
      case CUSTOMER_APPROVED:
        return ''
      case CUSTOMER_REJECTED:
        return ''
      default:
        return '';
    }
  }

  getActivationActionsJsx = (product, index) => {
    if (this.props.customer === true) {
      return this.getCustomerActions(product, index);
    } else if (this.props.role === ADMIN_ROLE || this.props.role === CASE_WORKER_ROLE ||
      this.checkForOwner()) {
      return this.getCIMakerActions(product);
    } else {
      return this.getCICheckerActions(product);
    }
  }

  renderActivationActionsSection = (product, index) => {
    if (product.activationStatus !== DATA_INCOMPLETE) {
      return (
        <div className="gls-activation-list__item__body__actions-section">
          {this.getActivationActionsJsx(product, index)}
        </div>
      );
    } else {
      return '';
    }
  }

  showConfirmationSection = (product) => {
    if (this.props.customer === true && product.activationStatus === READY_FOR_CUSTOMER_REVIEW) {
      return true;
    } else {
      return false;
    }
  }

  downloadGlsForm = (product, docType) => {
    const { caseId, id, glsProductType } = product || {};
    let apiUrl = `/cases/${caseId}/products/${id}/downloadGLSDocument`
    if (docType === "SSF") {
      apiUrl = `/cases/${caseId}/downloadDocument?docType=${docType}`
    }
    eapiClient(apiUrl, {
      method: 'GET',
      responseType: 'blob',
    })
      .then((response, filename, mime) => {
        var blob = new Blob([response.data], { type: mime || 'application/octet-stream' });
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          // IE workaround for "HTML7007: One or more blob URLs were
          // revoked by closing the blob for which they were created.
          // These URLs will no longer resolve as the data backing
          // the URL has been freed."
          window.navigator.msSaveBlob(blob, `${this.props.owningCase._caseId}_${glsProductType.name}.pdf`);
        }
        else {
          var blobURL = window.URL.createObjectURL(blob);
          var tempLink = document.createElement('a');
          tempLink.style.display = 'none';
          tempLink.href = blobURL;
          tempLink.setAttribute('download', `${this.props.owningCase._caseId}_${glsProductType.name}.pdf`);

          // Safari thinks _blank anchor are pop ups. We only want to set _blank
          // target if the browser does not support the HTML5 download attribute.
          // This allows you to download files in desktop safari if pop up blocking
          // is enabled.
          if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank');
          }

          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          window.URL.revokeObjectURL(blobURL);
        }
        this.getDocStatus()
      });
  }

  setApprovalConsent = (event) => {
    this.setState({ consentsGiven: { ...this.state.consentsGiven, [event.target.name]: event.target.checked } });
  }

  toProductPage = (product) => {
    const { caseId, id } = product;
    if (product.glsProductType.value === 'cashcon') {
      this.props.history.push({
        pathname: `/case-body/capture-product-cashcon/${caseId}/${id}`,
        state: { isNavigate: true }
      });
    } else if (product.glsProductType.value === 'notionalPool') {
      this.props.history.push({
        pathname: `/case-body/capture-product-notional-pooling/${caseId}/${id}`,
        state: { isNavigate: true }
      });
    } else if (product.glsProductType.value === 'interest') {
      this.props.history.push({
        pathname: `/case-body/capture-product-interest-enhancement/${caseId}/${id}`,
        state: { isNavigate: true }
      });
    }
  }

  setCustomerCheckbox = (product, event) => {
    let _product = { ...product }
    _product[event.target.name] = event.target.value

    this.setState({
      currentProduct: _product
    })
  }

  getGlsType = (item) => {
    var currentWord = Translations(this.props.pageJson.par.documentation_pack_glsProducts.options, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    const glsType = convertStringToArrayForOption(currentWord);
    if (glsType !== undefined) {
      glsType.filter(countItem => {
        if (countItem.split('=')[0] === item.value) {
          item.name = countItem.split('=')[1]
        }
      })
      return item;
    }
  }

  generateSSF = (product = {}) => {
    const { caseId = '' } = product
    this.props.blockUi && this.props.blockUi()
    eapiClient('/cases/' + caseId + '/products/generate-ssf-document')
      .then(({ data }) => {
        return data
      }).then(({ data }) => {
        const pollApiPayload = {
          caseIds: [
            caseId
          ]
        }
        this.pollingApiTimerId = setInterval(async () => {
          try {
            const response = await this.pollGenerateSSF(pollApiPayload)
            if (response && response.status === 201) {
              this.stopPollingApi()
              this.setState({
                isSSFGenerated: true
              })
              this.getDocStatus()
              this.props.unBlockUi && this.props.unBlockUi()
            }
          }
          catch (error) {
            console.log(error)
            this.stopPollingApi()
            this.props.unBlockUi && this.props.unBlockUi()
          }
        }, 5000);
      }).catch(err => {
        console.log(err)
        this.props.unBlockUi && this.props.unBlockUi()
      })
  }

  pollGenerateSSF = (pollApiPayload = {}) => {
    return eapiClient('/cases/poll-generate-ssf-draft', {
      method: "POST",
      data: JSON.stringify(pollApiPayload)
    }).then(({ data, status }) => {
      return ({ data, status })
    })
  }

  stopPollingApi = () => {
    clearInterval(this.pollingApiTimerId)
    this.pollingApiTimerId = null
  }

  handleAddSSFComments = (comment) => {
    const { caseId } = (this.props.glsProductsList && this.props.glsProductsList.length && this.props.glsProductsList[0]) || {}
    const apiUrl = `/cases/addSSFComment/${caseId}`
    const { username, emailAddress } = this.props.userDetails
    const payload = {
      commentText: comment,
      username: username,
      email: emailAddress
    }
    eapiClient(apiUrl, {
      method: 'PUT',
      data: JSON.stringify(payload)
    })
      .then(({ data }) => {
        if (data.responseData) {
          this.setState({ ssfComments: data.responseData });
        }
      });
  }

  getSSFComments = () => {
    const { caseId } = (this.props.glsProductsList && this.props.glsProductsList.length && this.props.glsProductsList[0]) || {}
    const apiUrl = `/cases/${caseId}/SSFComments`
    eapiClient(apiUrl).then(({ data }) => {
      if (data && data.responseData) {
        this.setState({
          ssfComments: data.responseData
        })
      }
    })
  }

  getDocStatus = async () => {
    const { data } = await eapiClient("/cases/" + this.props.owningCase.caseId + "/doc-status", { timeout: 420000 })
    if (data.responseData) {
      this.setState({
        docStatus: data.responseData
      })
    }
  }

  showSSFFormDownload = () => {
    return !this.props.customer && (this.state.docStatus && this.state.docStatus.data && this.state.docStatus.data.length &&
      this.state.docStatus.data.find(status => status.ssfGenerationDate) && this.state.docStatus.data.find(status => status.ssfGenerationDate).ssfGenerationDate ||
      this.state.isSSFGenerated || (this.props.owningCase && this.props.owningCase.ssfPackURL))
  }

  getSSFFormDownloadDate = () => {
    let date = "SSF Form v001 "
    if (this.state.docStatus && this.state.docStatus.data && this.state.docStatus.data.length) {
      const { ssfGenerationDate } = this.state.docStatus.data.find(status => status.ssfGenerationDate) || {}
      if (ssfGenerationDate) {
        date = date + ssfGenerationDate
      }
    }
    return date
  }

  getGLSFormDownloadDate = (product = {}) => {
    let date = "GLS Form v001 "
    const glsAgent = this.state.docStatus.data && this.state.docStatus.data.find((entity) => entity.entityName === product.glsAgent.name)

    if (glsAgent && glsAgent.glsFormGenerationDetails && product.glsProductType && product.glsProductType.name && glsAgent.glsFormGenerationDetails[product.glsProductType.name.toLowerCase().replace(" ", '')]) {
      return date + glsAgent.glsFormGenerationDetails[product.glsProductType.name.toLowerCase().replace(" ", '')]
    }
    return date
  }

  showGenerateSSF = () => {
    const { sowGlsId, sowEntityId } = (this.props.glsProductsList && this.props.glsProductsList.find(product => product.glsProductType.value)) || {}
    return Boolean(sowGlsId || sowEntityId)
  }

  render() {
    // let checked = false;
    return (
      <div className="gls-activation-list">
        {
          this.props.glsProductsList.map((product, index) => {
            return (
              <div className={classnames({
                "gls-activation-list__item": true,
                "block": this.props.caseMenu.isEditing
              })} key={product.id}>
                <div className="gls-activation-list__item__body">
                  <div className={classnames({
                    "gls-activation-list__item__body__product-details-section": true
                  })}>
                    <div className={classnames({ "no-event": UNCLICKABLE_GLS_ACTIVATIONS_STATUSES.includes(product.activationStatus) })}>
                      <h4
                        className="product-title"
                        onClick={this.toProductPage.bind(this, product)}
                      >
                        {this.getGlsType(product.glsProductType).name}
                        <i className="icon icon-chevron-right"></i>
                      </h4>
                      <p className="product-detials">{this.translations(this.props.pageJson.par.documentation_pack_glsProducts.agentText)}: {product.glsAgent.name} ({product.title})</p>
                    </div>
                  </div>
                  {this.renderStatusAndCommentsSection(product, index)}
                  {this.renderActivationActionsSection(product, index)}
                </div >
                <div className="gls-activation-list__item__footer">
                  <p className="download-info">{this.state.docStatus && this.getGLSFormDownloadDate(product)}</p>
                  <i className="icon icon-download" onClick={this.downloadGlsForm.bind(this, product)}></i>
                </div>
                {
                  this.showConfirmationSection(product) ? (
                    <div className="gls-activation-list__item__confirmation-section">
                      <CheckBox
                        name={product.id}
                        id={product.id}
                        onChange={this.setApprovalConsent}
                      />
                      <label htmlFor={product.id}>{this.translations(this.props.pageJson.par.checkbox_confirmation.text)}</label>
                    </div>
                  ) : ''
                }
              </div >
            )
          })
        }
        {
          this.state.glsSubmitToCiChecker !== undefined &&
          <SubmitToCheckerModal
            bsClass="submit-to-checker-modal"
            showDialog={this.state.showSubmitToCheckerModal}
            toggleDialog={this.toggleSubmitToChekerModal}
            modalTitle={this.translations(this.state.glsSubmitToCiChecker.page_title_mainTitle.pageHeading)}
            par={this.translations(this.state.glsSubmitToCiChecker.static_text_addANewComment.text1)}
            label={this.translations(this.state.glsSubmitToCiChecker.static_text_addANewComment.text2)}
            cancelBtn={this.translations(this.state.glsSubmitToCiChecker.button_addComment.text)}
            submitBtn={this.translations(this.state.glsSubmitToCiChecker.button_done.text)}
            _onSubmitToChecker={this._onSubmitToChecker}
          />
        }
        {
          this.state.glsSubmitToClientSphere !== undefined &&
          <ClientSphereCheckerConfirmationModal
            bsClass="submit-to-checker-modal"
            showDialog={this.state.showClientSphereCheckerModal}
            toggleDialog={this.toggleSubmitToChekerModal}
            par={this.translations(this.state.glsSubmitToClientSphere.static_text_Notificationcomment.text1)}
            cancelBtn={this.translations(this.state.glsSubmitToClientSphere.button_cancel.text)}
            submitBtn={this.translations(this.state.glsSubmitToClientSphere.button_confirm.text)}
            _onSubmitToChecker={this._onSubmitToClientSphere}
          />
        }
        {
          this.state.glsCustomerAckWithinGDOCS !== undefined &&
          <CustomerAckWithinConfirmationModal
            bsClass="submit-to-customer-modal"
            showDialog={this.state.showWithinGdocsModal}
            toggleDialog={this.toggleSubmitToChekerModal}
            par={this.translations(this.state.glsCustomerAckWithinGDOCS.static_text_Notificationcomment.text1)}
            cancelBtn={this.translations(this.state.glsCustomerAckWithinGDOCS.button_cancel.text)}
            submitBtn={this.translations(this.state.glsCustomerAckWithinGDOCS.button_confirm.text)}
            _onSubmitToCustomer={this.submitToCustomer}
          />
        }
        {
          this.state.glsCustomerAckOutsideGDOCS !== undefined &&
          <CustomerAckOutsideConfirmationModal
            bsClass="submit-to-customer-modal"
            showDialog={this.state.showOutsideGdocsModal}
            toggleDialog={this.toggleSubmitToChekerModal}
            par={this.translations(this.state.glsCustomerAckOutsideGDOCS.static_text_Notificationcomment.text1)}
            cancelBtn={this.translations(this.state.glsCustomerAckOutsideGDOCS.button_cancel.text)}
            submitBtn={this.translations(this.state.glsCustomerAckOutsideGDOCS.button_confirm.text)}
            _onSubmitToCustomer={this.submitToCustomerOutsidePortal}
          />
        }
        {
          this.state.rejectGlsProduct !== undefined &&
          <RejectProductModal
            bsClass="reject-product-modal"
            showDialog={this.state.showRejectModal}
            toggleDialog={this.toggleRejectModal}
            modalTitle={this.translations(this.state.rejectGlsProduct.page_title_mainTitle.pageHeading)}
            rejectType={this.state.rejectType}
            label={this.translations(this.state.rejectGlsProduct.static_text_reasonForRejection.title)}
            cancelBtn={this.translations(this.state.rejectGlsProduct.button_cancel.text)}
            submitBtn={this.translations(this.state.rejectGlsProduct.button_rejectProduct.text)}
            product={this.state.currentProduct}
            _onProductRejected={this._onProductRejected}
          />
        }

        {
          this.state.glsApprovalComments !== undefined &&
          <CommentsModal
            bsClass="comments-modal"
            showDialog={this.state.showCommentsModal}
            toggleDialog={this.toggleCommentsModal}
            modalTitle={this.translations(this.state.glsApprovalComments.page_title_mainTitle.pageHeading)}
            product={this.state.currentProduct}
            addCommentLabel={this.translations(this.state.glsApprovalComments.static_text_addANewComment.title)}
            addCommentBtn={this.translations(this.state.glsApprovalComments.button_addComment.text)}
            prevCommentsLabel="Previous comments"
            comments={this.state.currentProductComments || []}
            _onAddComment={this.postComment}
            doneBtn={this.translations(this.state.glsApprovalComments.button_done.text)}
          />
        }
        {
          this.showSSFFormDownload() ?
            <div className="gls-activation-list__item__footer" >
              <p className="download-info">{this.getSSFFormDownloadDate()}</p>
              <i className="icon icon-download" onClick={this.downloadGlsForm.bind(this, this.props.glsProductsList &&
                this.props.glsProductsList.find(product => product.glsProductType && product.glsProductType.value), "SSF")}></i>
            </div>
            : null
        }
        {
          this.showGenerateSSF() ? <div className='generate-ssf-button-wrapper'>
            <a
              className="activation-comments-link"
              onClick={() => { this.setState({ showSSFCommentsModal: true }) }}
              href='#'
              tabindex="0"
            >
              {((this.state.ssfComments && this.state.ssfComments.length) || 0) + " " + this.translations((this.props.pageJson && this.props.pageJson.par &&
                this.props.pageJson.par.ssf_commentLink) || "Additional comments")}
            </a>
            <button className="gdocs-btn-default gdocs-mleft-20 gdocs-btn-wrap btn-li btn-padding"
              onClick={() => this.generateSSF(this.props.glsProductsList && this.props.glsProductsList.find(product => product.glsProductType.value))}
            >
              {this.translations((this.props.pageJson && this.props.pageJson.par && this.props.pageJson.par.guidebutton_generateSSF &&
                this.props.pageJson.par.guidebutton_generateSSF.text) || "Generate SSF")}
            </button>
          </div> : null
        }
        {
          this.state.glsApprovalComments !== undefined &&
          <SSFCommentsModal
            bsClass="comments-modal"
            showDialog={this.state.showSSFCommentsModal}
            toggleDialog={() => {
              this.setState({ showSSFCommentsModal: false });
              this.props.onActionPerformed && this.props.onActionPerformed()
            }}
            modalTitle={this.translations(this.state.glsApprovalComments && this.state.glsApprovalComments.page_title_mainTitle &&
              this.state.glsApprovalComments.page_title_mainTitle.ssfPageHeading)}
            // product={this.state.currentProduct}
            addCommentLabel={this.translations(this.state.glsApprovalComments.static_text_addANewComment.title)}
            addCommentBtn={this.translations(this.state.glsApprovalComments.button_addComment.text)}
            prevCommentsLabel="Previous comments"
            comments={this.state.ssfComments || []}
            _onAddComment={this.handleAddSSFComments}
            doneBtn={this.translations(this.state.glsApprovalComments.button_done.text)}
          />
        }
      </div >
    )
  }
}


GlsActivationList.defaultProps = {
  glsProductsList: []
}

GlsActivationList.propTypes = {
  glsProductsList: PropTypes.arrayOf(PropTypes.object).isRequired,
  role: PropTypes.string.isRequired,
  isCIChecker: PropTypes.bool.isRequired,
  currentUser: PropTypes.object.isRequired,
  onActionPerformed: PropTypes.func
}
const mapStateToProps = state => {
  return {
    customer: state.auth.userDetails.roleDetails.customer,
    caseMenu: state.caseMenuInfo,
    owningCase: electOwningCase(state.cases),
    caseOwner: state.caseOwner,
    userDetails: state.auth.userDetails
  }
}
export default connect(mapStateToProps, null)(GlsActivationList);

class SubmitToCheckerModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValid: false
    };
  }

  handleInputChange = (event) => {
    var inputValid = true;
    var emailAddress = event.target.value;
    if (emailAddress === undefined || emailAddress === '') {
      inputValid = false;
    }
    this.setState({
      emailAddress,
      inputValid
    });
  }

  _onSubmit = () => {
    this.props._onSubmitToChecker(this.state.emailAddress);
  }

  render() {
    return (
      <Modal
        show={this.props.showDialog}
        onClose={this.props.toggleDialog}
        bsClass={this.props.bsClass}
      >
        <ModalHeader title={this.props.modalTitle} />
        <ModalBody>
          <p>{this.props.par}</p>
          <label>{this.props.label}</label>
          <input type="text" name="checkerEmail" onChange={this.handleInputChange} />
        </ModalBody>
        <ModalFooter>
          <button className="gdocs-btn-default"
            onClick={this.props.toggleDialog}>
            {this.props.cancelBtn}
          </button>
          <button
            className="gdocs-btn-primary"
            onClick={this._onSubmit}
            disabled={!this.state.inputValid}
          >
            {this.props.submitBtn}
          </button>
        </ModalFooter>
      </Modal>
    )
  }
}

class ClientSphereCheckerConfirmationModal extends React.Component {
  constructor(props) {
    super(props);
  }

  _onSubmit = () => {
    this.props._onSubmitToChecker();
  }

  render() {
    return (
      <Modal
        show={this.props.showDialog}
        onClose={this.props.toggleDialog}
        bsClass={this.props.bsClass}
      >
        <ModalHeader title={this.props.modalTitle} />
        <ModalBody>
          <p>{this.props.par}</p>
        </ModalBody>
        <ModalFooter>
          <button className="gdocs-btn-default"
            onClick={this.props.toggleDialog}>
            {this.props.cancelBtn}
          </button>
          <button
            className="gdocs-btn-primary"
            onClick={this._onSubmit}
          >
            {this.props.submitBtn}
          </button>
        </ModalFooter>
      </Modal>
    )
  }
}

class CustomerAckWithinConfirmationModal extends React.Component {
  constructor(props) {
    super(props);
  }

  _onSubmit = () => {
    this.props._onSubmitToCustomer();
  }

  render() {
    return (
      <Modal
        show={this.props.showDialog}
        onClose={this.props.toggleDialog}
        bsClass={this.props.bsClass}
      >
        <ModalHeader title={this.props.modalTitle} />
        <ModalBody>
          <p>{this.props.par}</p>
        </ModalBody>
        <ModalFooter>
          <button className="gdocs-btn-default"
            onClick={this.props.toggleDialog}>
            {this.props.cancelBtn}
          </button>
          <button
            className="gdocs-btn-primary"
            onClick={this._onSubmit}
          >
            {this.props.submitBtn}
          </button>
        </ModalFooter>
      </Modal>
    )
  }
}

class CustomerAckOutsideConfirmationModal extends React.Component {
  constructor(props) {
    super(props);
  }

  _onSubmit = () => {
    this.props._onSubmitToCustomer();
  }

  render() {
    return (
      <Modal
        show={this.props.showDialog}
        onClose={this.props.toggleDialog}
        bsClass={this.props.bsClass}
      >
        <ModalHeader title={this.props.modalTitle} />
        <ModalBody>
          <p>{this.props.par}</p>
        </ModalBody>
        <ModalFooter>
          <button className="gdocs-btn-default"
            onClick={this.props.toggleDialog}>
            {this.props.cancelBtn}
          </button>
          <button
            className="gdocs-btn-primary"
            onClick={this._onSubmit}
          >
            {this.props.submitBtn}
          </button>
        </ModalFooter>
      </Modal>
    )
  }
}

class RejectProductModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleInputChange = (event) => {
    this.setState({ rejectReason: event.target.value });
  }

  _onReject = () => {
    this.props._onProductRejected(this.props.rejectType, this.state.rejectReason);
  }

  render() {
    return (
      <Modal
        show={this.props.showDialog}
        onClose={this.props.toggleDialog}
        bsClass={this.props.bsClass}
      >
        <ModalHeader title={this.props.modalTitle} />
        <ModalBody>
          <label className="product-desc">{this.props.product.glsProductType.name}</label>
          <label className="product-desc">Agent: {this.props.product.glsAgent.name} ({this.props.product.title})</label>
          <hr></hr>
          <p>{this.props.par}</p>
          <label className="reason-label">{this.props.label}</label>
          <textarea className="reason-input" name="rejectReason" onChange={this.handleInputChange}></textarea>
        </ModalBody>
        <ModalFooter>
          <button
            className="gdocs-btn-default"
            onClick={this.props.toggleDialog}
          >
            {this.props.cancelBtn}
          </button>
          <button
            className="gdocs-btn-primary"
            onClick={this._onReject}
            disabled={this.state.rejectReason === undefined || this.state.rejectReason === ''}
          >
            {this.props.submitBtn}
          </button>
        </ModalFooter>
      </Modal>
    )
  }
}

class CommentsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValid: false
    };
  }

  handleInputChange = (event) => {
    var inputValid = true;
    var comment = event.target.value;
    if (comment === undefined || comment === '') {
      inputValid = false;
    }
    this.setState({
      comment,
      inputValid
    });
  }

  _onAddComment = () => {
    this.setState({ comment: '' });
    this.props._onAddComment(this.props.product.id, this.state.comment);
  }

  render() {
    return (
      <Modal
        show={this.props.showDialog}
        onClose={this.props.toggleDialog}
        bsClass={this.props.bsClass}
      >
        <ModalHeader title={this.props.modalTitle} />
        <ModalBody>
          <div className="product-deatails">
            <label className="product-desc">{this.props.product.glsProductType.name}</label>
            <label className="product-desc">Agent: {this.props.product.glsAgent.name} ({this.props.product.title})</label>
          </div>
          <div className="comments-conatiner">
            <div className="add-comments-section">
              <label>{this.props.addCommentLabel}</label>
              <textarea name="comment" value={this.state.comment} onChange={this.handleInputChange}></textarea>
              <button
                className="gdocs-btn-default"
                onClick={this._onAddComment}
                disabled={this.state.comment === undefined || this.state.comment === ''}
              >
                {this.props.addCommentBtn}
              </button>
            </div>
            <div className="previous-comments-section">
              <h5>{this.props.prevCommentsLabel}</h5>
              <ul className="comments-list">
                {
                  this.props.comments.map((comment, index) => (
                    <li className="comments-list__item" key={index}>
                      <div className="gls-comments-list__item__comment-details">
                        <label className="username">{comment.userName}</label>
                        <label className="time-stamp">{`${moment(comment.sentOn).format("DD MMM YY, h:mm")}`}</label>
                      </div>
                      <div className="comments-list__item__comment">
                        {
                          comment.headerText ? <label className="header">{comment.headerText}</label> : ''
                        }
                        <p className="comment-text">{comment.comment}</p>
                      </div>
                    </li>
                  ))
                }
              </ul>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <hr></hr>
          <button
            className="gdocs-btn-primary"
            onClick={this.props.toggleDialog}
          >
            {this.props.doneBtn}
          </button>
        </ModalFooter>
      </Modal>
    )
  }
}

class SSFCommentsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValid: false
    };
  }

  handleInputChange = (event) => {
    var inputValid = true;
    var comment = event.target.value;
    if (comment === undefined || comment === '') {
      inputValid = false;
    }
    this.setState({
      comment,
      inputValid
    });
  }

  _onAddComment = () => {
    this.setState({ comment: '' });
    this.props._onAddComment(this.state.comment);
  }

  render() {
    return (
      <Modal
        show={this.props.showDialog}
        onClose={this.props.toggleDialog}
        bsClass={this.props.bsClass}
      >
        <ModalHeader title={this.props.modalTitle} />
        <ModalBody>
          <div className="comments-conatiner">
            <div className="add-comments-section">
              <label>{this.props.addCommentLabel}</label>
              <textarea name="comment" value={this.state.comment} onChange={this.handleInputChange}></textarea>
              <button
                className="gdocs-btn-default"
                onClick={this._onAddComment}
                disabled={this.state.comment === undefined || this.state.comment === ''}
              >
                {this.props.addCommentBtn}
              </button>
            </div>
            <div className="previous-comments-section">
              <h5>{this.props.prevCommentsLabel}</h5>
              <ul className="comments-list">
                {
                  this.props.comments.map((comment, index) => (
                    <li className="comments-list__item" key={index}>
                      <div className="gls-comments-list__item__comment-details">
                        <label className="username">{comment.username}</label>
                        <label className="time-stamp">{`${moment(comment.createdOn).format("DD MMM YY, h:mm")}`}</label>
                      </div>
                      <div className="comments-list__item__comment">
                        {
                          comment.headerText ? <label className="header">{comment.headerText}</label> : ''
                        }
                        <p className="comment-text">{comment.commentText}</p>
                      </div>
                    </li>
                  ))
                }
              </ul>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <hr></hr>
          <button
            className="gdocs-btn-primary"
            onClick={this.props.toggleDialog}
          >
            {this.props.doneBtn}
          </button>
        </ModalFooter>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/Activation/GlsActivationList/GlsActivationList.js